/* eslint-disable @typescript-eslint/no-unused-vars */
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { cloneElement } from 'react';

import { useDisclosure } from '@/hooks/useDisclosure';
import { deleteFaq, getFaqs } from '@/request/hubbot-api';
import { selectedQuestion } from '@/signals';

interface DeleteModalProps {
  button: React.ReactElement;
}

export const DeleteModal = ({ button }: DeleteModalProps) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleDelete = async (): Promise<void> => {
    onClose();
    try {
      selectedQuestion.value && (await deleteFaq(selectedQuestion.value.faqId));
      await getFaqs();
      selectedQuestion.value = null;
    } catch (e) {
      console.error(e);
    }
  };

  const clonedButton = cloneElement(button, { onClick: onOpen });

  return (
    <>
      {clonedButton}
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="flex items-center gap-2">
            <span className="bg-red-200 rounded-full h-10 w-10 flex-center">
              <WarningAmberIcon color="error" />
            </span>
            Eliminar pregunta
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Se va a borrar la pregunta de forma permanente.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            onClick={(e) => {
              void handleDelete();
            }}
            variant="contained"
            color="primary"
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
